var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBandcampLogoinline = function SvgBandcampLogoinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 15,
    viewBox: "0 0 25 15"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#639AA9",
    fillRule: "evenodd",
    d: "M16.933 14.834H0L7.907.074h16.934z"
  })));
};
export default SvgBandcampLogoinline;